<template>
  <div style="height: inherit" class="responsive-drawer-layout">
    <div class="wrapper touch d-flex flex-column mt-0 pa-0 background mx-xl-auto">
      <!-- Small header over the whole width and with the same height as PDF.js toolbar-->

      <!-- Row with drawer and content area-->
      <div class="d-flex flex-row background inherit-height">
        <!-- Drawer container -->
        <div
          v-if="!mx_needsDrawer && hasDrawerSlot"
          id="nav-drawer"
          v-click-outside="(mx_isLeftDrawerOpen = false)"
          :style="drawerStyle"
          class="drawer ma-0 pa-0"
          :class="`background-${themeName} drawer--${themeName}`"
        >
          <slot name="drawer"></slot>
        </div>

        <!-- Content area which can be used for PDF inline displaying or other content -->
        <!-- However the component is optimized for displaying PDF.js -->
        <div :style="contentStyle" class="content-container inherit-height ma-0 pa-0" :class="`background-${themeName}`">
          <!--a vue transition cannot be used since it causes pdf.js to throw a 'cannot scroll exception'-->
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <!-- fake permanent set to true to avoid closing drawer when clicking inside of navDrawer header, which is not part ov v-navigation-drawer and thus
          makes drawer close
     -->
    <v-navigation-drawer
      v-if="mx_needsDrawer"
      v-model="mx_isLeftDrawerOpen"
      absolute
      temporary
      :permanent="mx_needsDrawer && mx_isLeftDrawerOpen"
      :width="xs ? '95vw' : drawerWidth"
      :style="`height:100%;overflow:hidden;background:${navDrawerBackground} `"
    >
      <slot name="drawer"></slot>
    </v-navigation-drawer>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import responsiveDrawerLayoutMixin from './responsiveDrawerLayoutMixin';
import { drawerWidth, drawerWidth_xl } from '@/common/constants';

export default {
  name: 'ResponsiveDrawerLayout',
  mixins: [common, configMixin, responsiveDrawerLayoutMixin],

  props: {
    drawerWidth: { type: Number, default: drawerWidth },
    drawerWidth_xl: { type: Number, default: drawerWidth_xl },

    isContentPdf: { type: Boolean, default: true },
    backgroundImgUrl: String,
  },

  mounted() {
    // Close drawer when mounted
    this.mx_isLeftDrawerOpen = false;
  },
  computed: {
    pageBackgroundUrl() {
      console.debug('get pageBackground', this.mx_pageBackground);
      if (!this.mx_pageBackground) return null;
      return this.assetUrl(this.mx_pageBackground);
    },
    pageStyle() {
      console.debug('get pageStyle', this.mx_pageBackground);
      let pageStyle = `background-image:url('${this.pageBackgroundUrl}') !important`;
      console.debug('pageStyle', pageStyle);
      return pageStyle;
    },
    hasDrawerSlot() {
      return !!this.$slots['drawer'];
    },
    drawerStyle() {
      return { width: `${this.mx_currentDrawerWidthStr}` };
    },
    contentStyle() {
      let style = { zIndex: 1001 };
      if (this.isContentPdf) {
        style = {
          marginLeft: this.xs ? '0px !important' : '0px', //Required for PDF.js
          marginRight: this.xs ? '0px !important' : '0px', //Required for PDF.js
          overflowY: 'hidden',
        };
      }

      if (!this.hasDrawerSlot) {
        style.width = '100vw';
      } else {
        style.width = this.mx_needsDrawer ? `100vw` : `calc(100% - ${this.mx_currentDrawerWidthStr})`;
      }

      if (this.mx_pageBackground) {
        style.background = `url('${this.pageBackgroundUrl}') `;
        style.backgroundSize = 'cover';
      }

      return style;
    },
    // Background of navdrawer cannot be set as class. Use identical colors as in .background-light and dark, see app,
    navDrawerBackground() {
      return this.darkMode ? '#191919' : '#fefefe';
    },
  },
  watch: {
    mx_isLeftDrawerOpen(newValue, oldValue) {
      if (newValue) {
        console.debug('mx_isLeftDrawerOpen watcher');
        setTimeout(() => {
          let overlays = document.getElementsByClassName('v-overlay__scrim');
          if (overlays && overlays.length >= 1) {
            let el = overlays[0];
            el.addEventListener('click', () => {
              this.mx_isLeftDrawerOpen = false;
            });
          }
        }, 1000);
      }
    },
  },
};
</script>

<style scoped>
/* sm - small */
@media (min-width: 600px) and (max-width: 959px) {
}

/* md - medium */
@media (min-width: 960px) and (max-width: 1263px) {
}

/* md - medium */
@media (width: 980px) {
}

/* lg - large */
@media (min-width: 1264px) and (max-width: 1904px) {
}

/* xl - extra large */
@media (min-width: 1905px) {
  .wrapper {
    max-width: 1904px;
    margin-right: auto !important; /* mx-xl-auto */
    margin-left: auto !important; /* mx-xl-auto */
  }
}

.wrapper {
  width: 100vw;
  height: 100% !important;
  transition: transform 400ms ease, top 500ms;
  transform: translateX(0);
  /* overscroll-behavior-y: contain; avoids pull-to-refresh */
}

.drawer--light {
  box-shadow: 1px 1px 1px 1px #e2e2e259;
}

.drawer--dark {
  box-shadow: 1px 1px 1px 1px #0b0a0a59;
}

.drawer {
  height: inherit;
  position: relative; /* changed to allow inner positionings with absolute*/
  z-index: 10000;
  overflow-y: scroll;
  overflow-x: hidden;
  -moz-overflow-style: none;
}

.drawer::-webkit-scrollbar {
  display: none;
}

.content-container {
  height: inherit;
}

.pdfjs-header {
  background: #474747;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.15), inset 0 -1px 0 rgba(255, 255, 255, 0.05), 0 1px 0 rgba(0, 0, 0, 0.15), 0 1px 1px rgba(0, 0, 0, 0.1);
  opacity: 1;
  z-index: 1000;
  height: 46px;

  position: absolute;
  top: -4px;
  left: 0;
  right: 0;
  z-index: 0;
}
</style>
